import React from "react";
import { Modal, ModalDialogProps } from "react-bootstrap";
import LoadingBox from "./loading-box";
import FlexBox from "./flex-box";
import ErrorBox from "./error-box";

interface SimpleModalProps extends ModalDialogProps {
  loading?: boolean;
  error?: string;
  open: boolean;
  close: () => void;
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: "sm" | "lg" | "xl";
  bodyClassName?: string;
  isStatic?: boolean;
}

const SimpleModal: React.FC<SimpleModalProps> = ({
  loading,
  error,
  open,
  close,
  title,
  subtitle,
  children,
  footer,
  size = "xl",
  bodyClassName = "",
  isStatic = true,
}) => {
  return (
    <Modal
      size={size}
      show={open}
      onHide={close}
      centered
      backdrop={isStatic ? "static" : true}
      keyboard={false}
      className="simple-modal"
      backdropClassName="simple-modal-backdrop"
    >
      {title && (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      {subtitle && <div className="px-3 pb-2 text-muted">{subtitle}</div>}
      {loading ? (
        <LoadingBox className="scrollable-content-250" />
      ) : (
        <Modal.Body className={`${bodyClassName}`}>
          {children}
          {error && (
            <FlexBox>
              <ErrorBox message={error} />
            </FlexBox>
          )}
        </Modal.Body>
      )}
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default SimpleModal;
